export default function BtnCheckBox({ nameEn, selectHandler, logic, name, color = 'primary' }) {
  return (
    <button
      value={nameEn}
      name={name}
      onClick={selectHandler}
      className={`py-1.5 px-3 md:py-2 md:px-4 rounded-full border-[1px] cursor-pointer transition-all ${
        logic
          ? `border-${color} text-${color} bg-${color} bg-opacity-10`
          : 'border-blackFont-400/80 text-blackFont-600 hover:bg-gray-100/70'
      } text-[12px]  md:text-[14px] flex items-center whitespace-nowrap font-medium`}
    >
      {name}
    </button>
  );
}
